import addItemForm from "./addItemForm";
export default {
  uploadImageButtonText: addItemForm.uploadImageButtonText,
  cancel: "إلغاء",
  cropSave: "حفظ الصورة",
};
